export const EMPLOYEE_ROUTE_NAMES = {
    LIST: "EmployeeList",
    PROFILE: "EmployeeProfile",
    CREATE: "EmployeeAdd",
    ADD: "EmployeeAdd",
    EDIT: "EmployeeEdit",
};
